import type { Guia } from '../tipos';

export const guiaAdministracao: Guia = {
  id: 'administracao',
  titulo: 'Usuários, unidades e links de senha',
  resumo:
    'Cadastrar profissionais, escolher o perfil, gerar o link de senha e manter as unidades de saúde.',
  perfis: ['admin', 'superadmin'],
  revisadoEm: '2026-10-17',
  secoes: [
    {
      id: 'usuario',
      titulo: 'Cadastrar um profissional',
      passos: [
        'No menu, abra **Usuários** e clique em **Novo usuário**.',
        'Preencha nome, e-mail institucional, **Perfil** e unidade. Para médico e enfermeiro, informe o conselho e o número do registro (COREN ou CRM): sem ele, a pessoa não registra doses.',
        'Clique em **Salvar**.',
      ],
      botoes: ['Novo usuário', 'Salvar'],
      imagem: {
        arquivo: 'admin-usuarios.png',
        descricao: 'Lista de usuários com o perfil, a situação e o último acesso.',
      },
    },
    {
      id: 'senha',
      titulo: 'Link de senha',
      passos: [
        'Abra o usuário e clique em **Gerar link de definição de senha**.',
        'Entregue o link à pessoa por um canal seguro. Ele é de uso único e tem validade; no primeiro acesso, o sistema pede o aviso de privacidade e a senha pessoal.',
      ],
      botoes: ['Gerar link de definição de senha'],
    },
    {
      id: 'unidades',
      titulo: 'Unidades de saúde',
      passos: [
        'Em **Unidades de saúde**, use **Nova unidade** para cadastrar UBS, maternidade ou casa da gestante, com o CNES.',
      ],
      botoes: ['Nova unidade'],
    },
    {
      id: 'pedidos',
      titulo: 'Pedidos de ajuda',
      passos: [
        'Quem esqueceu o e-mail pede ajuda pela tela de login. Os pedidos aparecem em **Pedidos de ajuda**.',
        'Depois de atender, marque **Atendido**.',
      ],
      botoes: ['Atendido'],
    },
  ],
};

export const guiaSuperadmin: Guia = {
  id: 'superadmin',
  titulo: 'Municípios, módulos, auditoria e sessões',
  resumo:
    'Tarefas do superadministrador: adesão dos municípios, módulos disponíveis e acompanhamento de segurança.',
  perfis: ['superadmin'],
  revisadoEm: '2026-10-17',
  secoes: [
    {
      id: 'municipios',
      titulo: 'Municípios',
      passos: [
        'Em **Municípios**, marque **Município participante do MetaEpi** e a **Data de adesão** para liberar o município.',
      ],
    },
    {
      id: 'modulos',
      titulo: 'Módulos disponíveis',
      passos: [
        'Em **Módulos disponíveis**, ligue ou desligue os agravos que aparecem no menu (sífilis, HIV, hepatites, Chagas) para todos os usuários.',
      ],
    },
    {
      id: 'seguranca',
      titulo: 'Auditoria, acessos e sessões',
      passos: [
        '**Auditoria:** quem alterou o quê, e quando. O registro não pode ser apagado; senhas e tokens nunca aparecem.',
        '**Registro de acessos:** entradas, tentativas e bloqueios.',
        '**Sessões ativas:** quem está conectado agora. Use **Encerrar** para desconectar uma sessão suspeita.',
      ],
      botoes: ['Encerrar'],
    },
  ],
};
